import { lifecycle } from 'recompose';
import { get, debounce } from 'lodash';

const maybeScroll = (subsection) => {
  const sect = document.querySelectorAll(`[data-subsection='${subsection}']`);
  if(sect && sect[0]) {
    sect[0].scrollIntoView();
  }
};

const debouncedMaybeScroll = debounce(maybeScroll, 100, { trailing: true });

const withScrollToSubSection = lifecycle({
  componentDidUpdate(prevProps) {
    const currentSection = get(this.props, 'location.query.section');
    const prevSection = get(prevProps, 'location.query.section');
    if(currentSection !== prevSection) {
      debouncedMaybeScroll(currentSection);
    }
  },
  componentDidMount() {
    const currentSection = get(this.props, 'location.query.section');
    if(currentSection) {
      debouncedMaybeScroll(currentSection);
    }
  },
});

export default withScrollToSubSection;


// WEBPACK FOOTER //
// ./src/views/static/import-documentation/with-scroll-to-subsection-hoc.js